import React from "react";

// progress: number 0–1
// label: string shown below the bar (e.g. "Phase 2 of 4", "Step 3 of 6")
export default function ProgressBar({ progress = 0, label = "" }) {
  const pct = Math.min(100, Math.max(0, progress * 100));

  return (
    <div className="tw-w-full tw-mt-7 tw-flex tw-flex-col tw-items-center tw-gap-2">
      <div className="tw-w-full tw-h-[3px] tw-rounded-sm" style={{ background: "rgba(234,225,214,0.2)" }}>
        <div
          className="tw-h-full tw-rounded-sm tw-transition-all tw-duration-700 tw-ease-in-out"
          style={{ width: `${pct}%`, background: "#CB5A3C" }}
        />
      </div>
      {label && (
        <p className="tw-text-xs tw-tracking-[0.5px]" style={{ color: "rgba(255,255,255,0.35)" }}>
          {label}
        </p>
      )}
    </div>
  );
}
